import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(
  () => ({
    menuCustom: {
      '& .MuiPopover-paper': {
        width: '430px;',
      },
      '& .MuiInput-underline:before': {
        border: '0',
      },
      '& .MuiList-root li': {
        padding: '4px 12px 4px 12px',
      },
    },
    rightCTA: {
      '& Button.MuiButtonBase-root': {
        width: 'max-content',
      },
      '& .MuiButton-root': {
        borderRadius: '10px',
      },
    },
    paymentCTA: {
      '& .MuiButtonBase-root': {
        color: '#fff',
        backgroundColor: '#1E8777',
      },
      '& .MuiButton-label': {
        marginLeft: 'unset',
        height: 'unset',
      },
    },
    alphaInput: {
      width: '100%',
      '& .MuiInputBase-root': {
        background: 'rgba(230,230,230, 0.3)',
        borderRadius: '5px',
        border: 'none',
        padding: '8px !important',
      },
      '& label': {
        margin: '6px',
      },
    },
  }),
  { name: 'MenuCustomStyle' },
);

export default useStyles;
